import React from 'react';

const PayrollIcon = () => {
  return (
    <div>
      <svg
        width='80'
        height='80'
        viewBox='0 0 80 80'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_i_42_96)'>
          <rect width='80' height='80' rx='40' fill='currentColor' />
          <path
            d='M24.4444 34.3333H20V57H60V34.3333H56.6667M47.7778 32.0667C48.6475 32.5796 49.3923 33.2864 49.9565 34.1343C50.5207 34.9821 50.8898 35.9491 51.0361 36.9629C51.1825 37.9767 51.1023 39.0111 50.8016 39.9888C50.5009 40.9666 49.9874 41.8623 49.2995 42.6092C48.6117 43.3561 47.7672 43.9347 46.8293 44.3019C45.8914 44.669 44.8842 44.8152 43.8831 44.7295C42.882 44.6439 41.9128 44.3285 41.048 43.807C40.1832 43.2856 39.4451 42.5715 38.8889 41.7181M42.2222 29.8C42.2222 31.6035 41.5198 33.3331 40.2696 34.6083C39.0194 35.8836 37.3237 36.6 35.5556 36.6C33.7874 36.6 32.0918 35.8836 30.8415 34.6083C29.5913 33.3331 28.8889 31.6035 28.8889 29.8C28.8889 27.9965 29.5913 26.2669 30.8415 24.9917C32.0918 23.7164 33.7874 23 35.5556 23C37.3237 23 39.0194 23.7164 40.2696 24.9917C41.5198 26.2669 42.2222 27.9965 42.2222 29.8Z'
            stroke='#FEFEFE'
            stroke-width='1.5'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </g>
        <defs>
          <filter
            id='filter0_i_42_96'
            x='-4.42632'
            y='-0.737721'
            width='84.4263'
            height='80.7377'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='BackgroundImageFix'
              result='shape'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dx='-4.42632' dy='-0.737721' />
            <feGaussianBlur stdDeviation='2.21316' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.564706 0 0 0 0 0.564706 0 0 0 0 0.866667 0 0 0 1 0'
            />
            <feBlend
              mode='normal'
              in2='shape'
              result='effect1_innerShadow_42_96'
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default PayrollIcon;
